import React from 'react';
import classNames from 'classnames';
import s from './title.module.css';
var Title = function Title(_ref) {
  var children = _ref.children,
    _ref$picture = _ref.picture,
    picture = _ref$picture === void 0 ? false : _ref$picture;
  return React.createElement("div", {
    className: classNames(s.text, picture && s.picture)
  }, children);
};
export default Title;